export default "__VITE_ASSET__DnfgbFIn__"